import * as changeCase from 'change-case'

const isObject = (obj: unknown) => obj !== null && typeof obj === 'object'
const isDate = (obj: unknown) => obj instanceof Date
const isArray = <T>(obj: unknown): obj is Array<T> => Array.isArray(obj)

function convertCase<T>(objectOrList: T, convertingFunction: (val: string) => string): T {
    // Check if the input is an array
    if (isArray<string>(objectOrList)) {
        return objectOrList.map((item) => convertCase(item, convertingFunction)) as T
    }
    // Check if the input is an object
    else if (isObject(objectOrList) && !isDate(objectOrList)) {
        const newObj: Record<string, unknown> = {}
        // Iterate through each key in the object
        for (const [key, value] of Object.entries(objectOrList)) {
            // Convert the key to snake_case and recurse for the value
            newObj[convertingFunction(key)] = convertCase(value, convertingFunction)
        }
        return newObj as T
    }
    // Base case: if it's neither an array nor an object, return it as is
    return objectOrList
}

/**
 * Recursively converts strings in list to camel case, or object keys to camel case,
 * depending on whether the argument is a list or an object.
 * @param {*} objOrList object or list of objects or list of strings
 * @returns the converted values
 */
function toCamelCase<T>(objectOrList: T): T {
    return convertCase(objectOrList, changeCase.camelCase)
}

/**
 * Recursively converts strings in list to snake case, or object keys to snake case,
 * depending on whether the argument is a list or an object.
 * @param {*} objOrList object or list of objects or list of strings
 * @returns the converted values
 */
function toSnakeCase<T extends Date | Array<unknown> | object>(objectOrList: T): T {
    return convertCase(objectOrList, changeCase.snakeCase)
}

export { toCamelCase, toSnakeCase }
